import { Type } from "../../../../.remote/gatsby-imgly-source/main/web/docs/PESDK/docs/shared/components/Type";
import * as React from 'react';
export default {
  Type,
  React
};